import RichTextField from './RichTextField';
import maxLengthWrapper from './maxLengthWrapper';

export default maxLengthWrapper(RichTextField);